import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useApi } from '../data';
import tracker from '../analytics/tracker';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function Login() {
  const [email, setEmail] = useState(process.env.REACT_APP_DEV_EMAIL || '');
  const [password, setPassword] = useState(
    process.env.REACT_APP_DEV_PASSWORD || ''
  );
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const api = useApi();

  useEffect(() => {
    tracker.pageViewOperatorLogin();
  }, []);

  const validate = () => {
    const e = {};
    if (!email.trim()) e.email = 'Please enter email';
    else if (!EMAIL_REGEX.test(email.trim()))
      e.email = 'Please enter a valid email';
    if (!password.trim()) e.password = 'Please enter password';
    setErrors(e);
    return !Object.keys(e).length;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    setErrors({});
    try {
      const { data } = await api.post('/portal/login', { email, password });
      if (data.access_token) {
        login(data.access_token);
        tracker.operatorLogin('success');
        navigate('/operator');
      } else {
        setErrors({ form: data.message || 'Invalid credentials' });
        tracker.operatorLogin('fail');
      }
    } catch {
      setErrors({ form: 'Login failed. Try again.' });
      tracker.operatorLogin('fail');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center px-3"
      style={{
        minHeight: '100dvh',
        background:
          'linear-gradient(135deg, #1a0000 0%, #4a0e0e 50%, #2d0a0a 100%)',
      }}
    >
      <div style={{ width: '100%', maxWidth: '360px' }}>
        <div className="text-center mb-4">
          <div style={{ fontSize: '3rem' }}>🔐</div>
          <h5 className="fw-bold mb-0" style={{ color: '#f5c842' }}>
            Operator Portal
          </h5>
          <small style={{ color: '#d4a528' }}>Kondarangi Keeranur</small>
        </div>

        <div
          className="p-4 rounded-3"
          style={{
            background: 'rgba(245, 200, 66, 0.05)',
            border: '1px solid rgba(245, 200, 66, 0.2)',
          }}
        >
          {errors.form && (
            <div
              className="p-2 rounded mb-3 small"
              style={{
                background: 'rgba(220, 53, 69, 0.1)',
                border: '1px solid rgba(220, 53, 69, 0.3)',
                color: '#ff6b6b',
              }}
            >
              {errors.form}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label
                className="d-block mb-1"
                style={{
                  color: '#e8b830',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                }}
              >
                Email
              </label>
              <input
                type="text"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  background: 'rgba(255,255,255,0.05)',
                  border: `1.5px solid ${errors.email ? '#ff6b6b' : 'rgba(245, 200, 66, 0.3)'}`,
                  color: '#f5c842',
                  padding: '0.75rem',
                }}
              />
              {errors.email && (
                <small style={{ color: '#ff6b6b' }}>{errors.email}</small>
              )}
            </div>
            <div className="mb-3">
              <label
                className="d-block mb-1"
                style={{
                  color: '#e8b830',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                }}
              >
                Password
              </label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  background: 'rgba(255,255,255,0.05)',
                  border: `1.5px solid ${errors.password ? '#ff6b6b' : 'rgba(245, 200, 66, 0.3)'}`,
                  color: '#f5c842',
                  padding: '0.75rem',
                }}
              />
              {errors.password && (
                <small style={{ color: '#ff6b6b' }}>{errors.password}</small>
              )}
            </div>
            <button
              type="submit"
              className="btn w-100 fw-bold"
              disabled={loading}
              style={{
                background: 'linear-gradient(135deg, #f5c842, #d4a528)',
                color: '#1a0000',
                border: 'none',
                padding: '0.75rem',
                fontSize: '1rem',
              }}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
